import generatePicker from 'antd/es/date-picker/generatePicker'
import type { Moment } from 'moment'
import momentGenerateConfig from 'rc-picker/lib/generate/moment'

const DatePickerWrapper = generatePicker<Moment>(momentGenerateConfig)

export default DatePickerWrapper
